// packages/shared/src/constants/currency.constants.ts
// Single source of truth for the currency list used across portfolio forms.
// ADR-20, section 5 — cross-package domain value-set.

// ── currency ────────────────────────────────────────────────────────────────
// Currencies supported in portfolio transaction/cashflow forms.
// Ordered by typical usage in the app (USD first, then others alphabetically).
export const CURRENCY_LIST = [
  "USD",
  "EUR",
  "RUB",
  "GBP",
  "CHF",
  "HKD",
  "CNH",
  "JPY",
  "CNY",
  "CAD",
  "AUD",
  "SGD",
  "KZT",
  "UAH",
  "BYN",
  "INR",
  "BRL",
  "MXN",
  "TRY",
  "AED",
] as const;
export type TCurrency = (typeof CURRENCY_LIST)[number];

// Labels are identical to the code — currency codes are universal.
export const CURRENCY_LABELS: Record<TCurrency, Record<string, string>> = {
  USD: { "en-US": "USD", "ru-RU": "USD" },
  EUR: { "en-US": "EUR", "ru-RU": "EUR" },
  RUB: { "en-US": "RUB", "ru-RU": "RUB" },
  GBP: { "en-US": "GBP", "ru-RU": "GBP" },
  CHF: { "en-US": "CHF", "ru-RU": "CHF" },
  HKD: { "en-US": "HKD", "ru-RU": "HKD" },
  CNH: { "en-US": "CNH", "ru-RU": "CNH" },
  JPY: { "en-US": "JPY", "ru-RU": "JPY" },
  CNY: { "en-US": "CNY", "ru-RU": "CNY" },
  CAD: { "en-US": "CAD", "ru-RU": "CAD" },
  AUD: { "en-US": "AUD", "ru-RU": "AUD" },
  SGD: { "en-US": "SGD", "ru-RU": "SGD" },
  KZT: { "en-US": "KZT", "ru-RU": "KZT" },
  UAH: { "en-US": "UAH", "ru-RU": "UAH" },
  BYN: { "en-US": "BYN", "ru-RU": "BYN" },
  INR: { "en-US": "INR", "ru-RU": "INR" },
  BRL: { "en-US": "BRL", "ru-RU": "BRL" },
  MXN: { "en-US": "MXN", "ru-RU": "MXN" },
  TRY: { "en-US": "TRY", "ru-RU": "TRY" },
  AED: { "en-US": "AED", "ru-RU": "AED" },
};

// Helper: check if a string is a known currency code.
export function isKnownCurrency(code: string): code is TCurrency {
  return CURRENCY_LIST.some((currency) => currency === code);
}
